import axios from "axios";
import qs from "qs";
import {API_HOST, AXIOS_DEFAULTS_TIMEOUT} from "../core/variables";

class AuthRepository {
    async verifyPassword(form: { username: string, password: string }) {
        const instance = axios.create();
        instance.defaults.withCredentials = true;
        instance.defaults.timeout = Number(AXIOS_DEFAULTS_TIMEOUT);
        return instance.post(
            `${API_HOST}/auth/verify-password`,
            qs.stringify(form),
            {
                headers: { 'content-type': 'application/x-www-form-urlencoded'}
            }
        );
    }

    async profile() {
        const instance = axios.create();
        instance.defaults.withCredentials = true;
        instance.defaults.timeout = Number(AXIOS_DEFAULTS_TIMEOUT);
        return instance.get(`${API_HOST}/auth/me`)
    }

    async updatePassword(password: string, newPassword: string) {
        return axios.put(`${API_HOST}/auth/password`, {password, newPassword});
    }

    async updateName(name: string) {
        return axios.put(`${API_HOST}/auth/name`, {name})
    }

    async delete() {
        return axios.delete(`${API_HOST}/auth`)
    }
}

const authRepository = new AuthRepository();

export default authRepository;
